import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for EditAdmin
export const EditAdmin = createSlice({
  name: "EditAdmin",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    edit_EditAdmin: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_EditAdmin: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_EditAdmin: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
      state.switchResponse = true;
    },
    EditAdmin_is_success: (state) => {
      state.isSuccess = false;
    },
    EditAdmin_complete_api: (state) => {
      state.api_completed = false;
    },
    false_switch_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default EditAdmin.reducer;
export const {
  edit_EditAdmin,
  success_api_call_EditAdmin,
  EditAdmin_complete_api,
  failure_api_call_EditAdmin,
  EditAdmin_is_success,
  false_switch_response,
} = EditAdmin.actions;
